<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { BtnLink } from '@shared/ui/links'

import { useDisciplineGeneralLinks } from '../model/discipline-general-links.hook'

defineOptions({
  name: 'DisciplineGeneralLinks',
})

const {
  refLinks,
} = useDisciplineGeneralLinks()
</script>

<template>
  <div class="discipline-general-links">
    <AppText name="body1-medium">
      Links
    </AppText>
    <div class="discipline-general-links__list">
      <BtnLink
        v-for="link in refLinks"
        :key="link.name"
        :link-name="link.name"
        :link-url="link.url"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineGeneralLinks.scss" />
